import React from 'react'
import styled from 'styled-components'
import { Slider as KaizenUiSlider, Icon } from '@nvidia/kaizen-ui'

const StyledSlider = styled.div`
  margin: 14px 0;
  display: flex;
  align-items: center;
  width: 100%;

  & > div {
    white-space: nowrap;
    margin-right: 14px;
  }

  & > .ui.slider {
    margin: 0 7px;
  }
`

export const Slider = ({ label, ...rest }) =>
  <StyledSlider>
    <div>{label}</div>
    <Icon name='subtract-circle-line' />
    <KaizenUiSlider {...rest} />
    <Icon name='add-circle-line' />
  </StyledSlider>



// WEBPACK FOOTER //
// ./src/components/Slider/Slider.js